module.exports = __webpack_public_path__ + "img/zipx85.fb080e1c.webp";